module.exports = __webpack_public_path__ + "img/windows_icon.23fe949f.svg";